import Container from 'react-bootstrap/Container';
import { Alert, Button, Card, Table, Modal, Accordion, Form } from 'react-bootstrap';
import {Sida,Rubrik,ContentWrapper,Stycke,StyckeCompact} from "../ContentStyles";
import useBackend, {CallAPI, Loading, SpinnerX, Check, CallAPIGet} from '../../services/useBackend';
import React, { useState ,useEffect, useReducer, fetchData,useMemo} from 'react';
import {useParams, useNavigate, useSearchParams} from 'react-router-dom';
import {MaterialReactTable} from 'material-react-table';
import {DateTimeToLocal, MultiselectGetOptions, MultiselectGetDefaultValues, escapedNewLineToLineBreakTag, ConcatLocalDateAndTime2ISO, SplitoutLocalDateFromISO, SplitoutLocalTimeFromISO, getOptions, metaLookUpTitle, metaLookUpAccountTitle} from '../../services/misc';
import { FaEdit, FaEraser, FaSortDown, FaSortUp, FaDownload, FaCheck } from 'react-icons/fa';

export default function Test(props) {
    const [saving,        setSaving]        = useState(false);
    const [resultVariant, setResultVariant] = useState('warning');
    const [resultText,    setResultText]    = useState('N/A');
    const [resultVisible, setResultVisible] = useState(false);

    var typingTimeout = null;

	async function handleChange(event){
        clearTimeout(typingTimeout);
		// typingTimeout = setTimeout(handleSave, 475);
	}

	async function handleSave(e){
        e.preventDefault();
		setSaving(true);
		setResultText("");
		setResultVisible(false);
		const VerificationForm = document.getElementById('NewPeriodForm');
		const formData = new FormData(VerificationForm);
		const formDataObj = Object.fromEntries(formData.entries());

        let {resultVariant, resultVisible, resultText, errorsException, jsondata} = await CallAPI('/api/v1/bookkeeping/bookKeepingPeriod',"POST",JSON.stringify(formDataObj));
        if (resultVariant!="success") {
            setResultVariant(resultVariant);
            setResultText(resultText);
            setResultVisible(resultVisible);
        } else {
            props.RefreshFn();            
        }
		setSaving(false);
	}

    return (
        <>      
            <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                    <Accordion.Header>Skapa redovisningsperiod</Accordion.Header>
                    <Accordion.Body>
                    För att kunna bokföra behöver du skapa en redovisningsperiod eller ladda upp en SIE-fil.
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>

                <Form id='NewPeriodForm' name='NewPeriodForm'  onSubmit={handleSave}>
                    <Form.Group className="mb-3" >
                        <Form.Label>Startdatum</Form.Label>								                            
                        <Form.Control type="date" name="StartDate" id="StartDate" placeholder="Startdatum" defaultValue={"2025-01-01"} onChange={handleChange} />
                    </Form.Group>

                    <Form.Group className="mb-3" >
                        <Form.Label>Slutdatum</Form.Label>								                            
                        <Form.Control type="date" name="EndDate" id="EndDate" placeholder="Slutdatum" defaultValue={"2025-12-31"} onChange={handleChange} />
                    </Form.Group>

                    <Form.Group className="mb-3"  hidden={!saving}>
                        <SpinnerX  />
                    </Form.Group>                                      
                    
                    <Form.Group className="mb-3"  hidden={!resultVisible}>
                        <Alert show={resultVisible} variant={resultVariant}  className="FormSpace">{resultText}</Alert> 
                    </Form.Group> 

                    <Form.Group className="mb-3">
                        <Button className="QmeButton" variant="primary" type="submit">Spara</Button>
                    </Form.Group>                     
                </Form>  											 													
        </>
      );      
};